var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "stores-list" },
    [
      _c("vue-client-only", [
        !_vm.adaptive.isMobile
          ? _c("div", { staticClass: "legend" }, [
              _c("span", { staticClass: "legend-address" }, [
                _vm._v("\n        Адрес\n      ")
              ]),
              _c("span", { staticClass: "legend-format" }, [
                _vm._v("\n        Формат\n      ")
              ]),
              _c("span", { staticClass: "legend-schedule" }, [
                _vm._v("\n        Часы работы\n      ")
              ])
            ])
          : _vm._e()
      ]),
      _vm.stores.length
        ? _c(
            "div",
            { staticClass: "list" },
            _vm._l(_vm.stores, function(store) {
              return _c("div", { key: store.id, staticClass: "item" }, [
                _c("div", { staticClass: "contacts" }, [
                  _c(
                    "div",
                    { staticClass: "metro" },
                    _vm._l(store.metro, function(metro) {
                      return _c("div", { key: metro.id }, [
                        _c("span", {
                          style: { backgroundColor: metro.line.color }
                        }),
                        _vm._v(_vm._s(metro.name) + "\n          ")
                      ])
                    }),
                    0
                  ),
                  _c("div", { staticClass: "address" }, [
                    _vm._v(
                      "\n          " + _vm._s(store.address) + "\n        "
                    )
                  ]),
                  _c("div", { staticClass: "phone" }, [
                    _c("span", [_vm._v("Телефон:")]),
                    _vm._v(
                      " " +
                        _vm._s(_vm._f("noBracesPhone")(store.phone)) +
                        "\n        "
                    )
                  ])
                ]),
                _c("div", { staticClass: "format" }, [
                  _c("span", [_vm._v("Формат:")]),
                  _vm._v(" " + _vm._s(store.workMode || "") + "\n      ")
                ]),
                _c("div", { staticClass: "schedule" }, [
                  _c("span", [_vm._v("Часы работы:")]),
                  _vm._v(
                    " " +
                      _vm._s(_vm._f("parseWorkSchedule")(store)) +
                      "\n      "
                  )
                ])
              ])
            }),
            0
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }